import React, { useEffect } from 'react';
import styles from './HomePage.module.scss';
import sections, { sectionIds } from './factory/HomePageSections';
import Messaging from '../../components/atoms/messaging/Messaging';
// import VerticalLine from '../../components/atoms/vertivalLine/VerticalLine';
import useScrollToTop from '../../app/hooks/useScrollToTop';
import useSmoothScroll from '../../app/hooks/useSmoothScroll';
import HomeButtonNav from '../../components/molecule/bottomNavigation/homeButtonNav/HomeButtonNav';
import { navigationItems } from '../../components/templates/homePageSections/home/homeCarousel/data';
import SiteHeader from '../../components/organism/site-header/SiteHeader';
import SideNav from './factory/side-navigation/SideNav_';

const lastSlideIndex = 9;

const HomePage = () => {
  useScrollToTop();

  const {
    currentSection,
    sectionRefs,
    scrollToSection,
    setCurrentSectionExternally,
  } = useSmoothScroll(sections);

  useEffect(() => {
    setCurrentSectionExternally(0);
  }, []);

  const handleNavSectionChange = (sectionIndex) => {
    setCurrentSectionExternally(sectionIndex);
    if (sectionIndex === lastSlideIndex) {
      setTimeout(() => setCurrentSectionExternally(0), 1250);
    }
  };

  const applyHash = (index) => {
    const hash = `#${sectionIds[index]}`;
    if (window.location.hash !== hash) history.replaceState(null, '', hash);
  };
  useEffect(() => {
    applyHash(currentSection);
  }, [currentSection]);

  return (
    <div className={styles.homePage}>
      <SiteHeader isHome invisible={currentSection === lastSlideIndex} />
      <SideNav activeIndex={currentSection} onChange={handleNavSectionChange} />
      <Messaging
        section={currentSection}
        handleSlideTopSection={() => setCurrentSectionExternally(0)}
        disableScrollToTop
      />

      {sections.map((SectionComponent, index) => (
        <section key={index} ref={sectionRefs[index]}>
          <SectionComponent currentSection={currentSection} />
        </section>
      ))}

      <HomeButtonNav
        data={navigationItems}
        variant="text-bold-20"
        active={currentSection}
        onClick={handleNavSectionChange}
        scrollToSection={setCurrentSectionExternally}
        isApplyNow
        ignoreLast
      />
    </div>
  );
};

export default HomePage;
